import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { useState } from 'react';
import { withServerDateFields } from '@/lib/server-date';
import { Button } from '../controls';
import { PerformanceForm } from '../performances';
import FilterableTable from '../table';

function buildColumnDefinitions() {
  const columnDefs = {};
  columnDefs.performerName = {
    header: 'Performer',
    filterable: true,
    sortable: true,
    showViewLink: false,
    handleClick: true,
  };
  columnDefs.startTime = {
    header: 'Start Time',
    filterable: false,
    sortable: true,
  };
  columnDefs.endTime = {
    header: 'End Time',
    filterable: false,
    sortable: true,
  };
  return columnDefs;
}

export function StagePerformances({
  performances,
  performers,
  stage,
  handlePerformanceSave,
  handlePerformanceDelete,
}) {
  const [showForm, setShowForm] = useState(false);
  const [selectedPerformance, setSelectedPerformance] = useState({});

  const openForm = (performance) => {
    setSelectedPerformance({ ...performance, stageId: stage.stageId });
    setShowForm(true);
  };

  const closeForm = () => {
    setSelectedPerformance({});
    setShowForm(false);
  };

  const handleDateChange = (dates) => {
    setSelectedPerformance((prev) => ({
      ...prev,
      ...dates[0],
    }));
  };

  const performerUpdated = (performer) => {
    const { performerId } = performer;
    setSelectedPerformance((prev) => ({
      ...prev,
      performer,
      performerId,
    }));
  };

  const savePerformance = (performance) => {
    const updatedPerformance = withServerDateFields({
      ...selectedPerformance,
      ...performance,
    });

    delete updatedPerformance.dates;
    delete updatedPerformance.performerName;
    delete updatedPerformance.stage;

    return handlePerformanceSave(updatedPerformance)
      .then(() => {
        setShowForm(false);
        setSelectedPerformance({});
      })
      .catch(() => {});
  };

  const deletePerformance = () => {
    handlePerformanceDelete(selectedPerformance)
      .then(() => {
        setShowForm(false);
        setSelectedPerformance({});
      })
      .catch(() => {});
  };

  let displayPerformances = performances;
  if (performances) {
    displayPerformances = performances.map((performance) => ({
      ...performance,
      performerName: performance.performer.performerName,
      startTime: moment(performance.startTime).format('YYYY-MM-DD h:mm a'),
      endTime: moment(performance.endTime).format('YYYY-MM-DD h:mm a'),
    }));
  }

  return (
    <>
      {showForm ? (
        <>
          <Button style={{ float: 'right' }} onClick={closeForm}>
            <FontAwesomeIcon icon={['fas', 'arrow-left']} /> Back
          </Button>
          <PerformanceForm
            performance={selectedPerformance}
            handleSave={savePerformance}
            handleDateChange={handleDateChange}
            performers={performers}
            performerUpdated={performerUpdated}
            handleRemove={deletePerformance}
          />
        </>
      ) : (
        <FilterableTable
          data={displayPerformances || []}
          tableTitle=""
          columns={buildColumnDefinitions()}
          includeFilter={false}
          allowAddNewRecord={true}
          addNewRecordText="Performance"
          viewLinkBuilder={openForm}
          editHandler={openForm}
          toggleModal={openForm}
        />
      )}
    </>
  );
}
